import { useEffect, useState } from "react";
import { ProCard } from "@ant-design/pro-components";
import { Button, Table, Space, notification, DatePicker, Modal, Form, Input, Spin, Typography, Tooltip, Switch, Select } from "antd";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { addTenantUsers, getTenantUsers, listUsersInTenant, removeTenantUsers } from "@/apis";
import { CheckCircleOutlined, CiCircleFilled, CodepenOutlined, EditOutlined, LoadingOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons"; 
import dayjs from 'dayjs';
import { useParams } from "react-router-dom";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useResourceContext } from "@/layouts/ResourceContext";

export const ChangeUsers = ({ id, goto}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useResourceNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOkDisabled, setIsModalOkDisabled] = useState(true);
  const [modalForm] = Form.useForm();
  const [users, setUsers] = useState([]);
  const [tenantUsers, setTenantUsers] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const { Text } = Typography;
  const { tenantName } = useResourceContext();
  useEffect(() => {
    const fetchTenantUsers = async () => {
      try {
        setIsLoading(true);
        const response = await listUsersInTenant(tenantName);
        setIsLoading(false);
        let tenantUsers = response.value || [];
        let i = 1;
        setTenantUsers(tenantUsers);      
      } catch (error) {
        console.error("get users failed:", error);
      }
    };

    fetchTenantUsers();
  }, [tenantName]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        const response = await getTenantUsers(id);
        setIsLoading(false);
        let users = response.value || [];
        let i = 1;
        setUsers(users);      
      } catch (error) {
        console.error("get users failed:", error);
      }
    };

    fetchUsers();
  }, [id]);

  const handleAdd = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    modalForm.validateFields().then(values => {
      const newData = values.names.map(name => {return {"name": name}});
      addTenantUsers(id, newData).then(({ status, value }) => {
        if (status === 'OK') {
          setUsers([...users, ...newData.map(user => {
            let isTenantAdmin = tenantUsers.find(item => item.name == user.name).isAdmin || false;
            return {...user, "isTenantAdmin": isTenantAdmin};
          })]);
        } else {
          notification.error({
            description: 'Add user failed!'
          });
        }
      }).catch((error) => {

      }).finally(() => {
        setIsModalVisible(false);    
        modalForm.resetFields();
        setIsModalOkDisabled(true);
      });      
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    modalForm.resetFields();
    setIsModalOkDisabled(true);
  };
  const handleModalValuesChange = () => {
    modalForm.validateFields().then(() => {
      setIsModalOkDisabled(false);
    }).catch(() => {
      //setIsModalOkDisabled(true);
      setIsModalOkDisabled(false);
    });
  };

  const handleDelete = (username) => {
    const removeItem = users.find(item => item.name == username);
    Modal.confirm({
      title: 'Delete User',
      content: 'Are you sure to delete user \'' + removeItem.name + '\' from current instance?' ,
      centered: true,
      onOk: () => {
        if(removeItem) {
          const revokeArray = [{
            name: username
          }]
          removeTenantUsers(id, revokeArray).then(({ status }) => {
            if (status === 'OK') {
              const newData = users.filter((item) => item.name !== username);
              setUsers(newData);
              notification.success({
                description: 'Delete User success!'
              });
            } else {
              notification.error({
                description: 'Delete user failed!'
              });
            }
          })
        }
      },
      onCancel: () => {
        console.log("Cancel delete");
      },
    });
    
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "name",
      width: '80%'
    },
    {
      title: "Is Tenant Admin",
      dataIndex: "isTenantAdmin",
      render: (text, record, index) => (
        record.isTenantAdmin && <CheckCircleOutlined />
      )
    },
    {
      title: '',
      width: 30,
      render: (_, record) => <Button size="small" shape="circle" icon={<MinusOutlined />} onClick={() => handleDelete(record.name)} />,
    }
  ];
  return (
    <div>
      <TopBreadcrumb />
      <ProCard split="vertical" style={{ marginTop: 20 }}>
        <ProCard title={
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', width: '100%', fontSize: 18, fontWeight: 500 }}>Change Users</div>
          </div>
        } extra={
          <Button size="small" shape="circle" icon={<PlusOutlined />} onClick={handleAdd} />
        } headerBordered colSpan="100%" headStyle={{ width: '100%' }}>
          <Spin tip="Loading" size="large" spinning={isLoading} indicator={<LoadingOutlined spin />}> 
          <Table columns={columns} dataSource={users}>

          </Table>
          </Spin>
          <Space>
            <Button onClick={() => {
              navigate({ resource: goto, action: "list" });
            }}>Close</Button>
          </Space>
        </ProCard>
      </ProCard>
      <Modal
        title="Add User"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okButtonProps={{ disabled: isModalOkDisabled }}
      >
        <Form form={modalForm} layout="vertical" onValuesChange={handleModalValuesChange}>
          <Form.Item
            name="names"
            label="User Name"
            rules={[
              {
                required: true,
              }
            ]}
          >
            <Select mode="multiple" showSearch options={tenantUsers.filter(tenantUser => { return !users.some(user => tenantUser.name === user.name);}).map((user) => {return {value: user.name, label: user.name}})}/>
          </Form.Item>
          {/* <Form.Item
            name="isAdmin"
            label="Is Tenant Admin"
          >
            <Switch defaultChecked={true}></Switch>
          </Form.Item> */}
        </Form>
      </Modal>
    </div>
  );
};